import React from "react";
import classnames from "classnames";
import { toast } from "react-toastify";
import { CheckboxIcon, SettingsIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { mutate } from "swr";
import { Tooltip } from "@mui/material";

import { store as fidelity } from "../../../../components/VerticalLayout/store";
import store, { setIsConsultModalOpened } from "../store";
import { ConfirmationArchive } from "../ConfirmationArchive";
import ConsultSvgIcon from "@components/Common/SvgIcons/ConsultSvgIcon";

export function CustomIcons({
    e,
    setDataIsUpdated,
    setIsHistoryModalOpened,
    isHistoryModalOpened,
    setSelectedRows,
    isFidelityArchived,
    selectedRows,
    setIsModalOpenedSupport,
    setIsConsult,
    setIsAddFidelityClicked,
    setFidelity,
}: any) {
    const { t } = useTranslation();
    const {
        // numberActiveMultiShop,
        // numberArchiveMultiShop,
        fidelityData,
        // shopsFidelityData,
        modify,
    } = useSnapshot(store);
    const { franchiseID, userID, oneShop, operatorID } = useSnapshot(fidelity);
    // eslint-disable-next-line
    const [fidelityState, setFidelityState] = React.useState<boolean>(
        e.selectedRow.isActive
    );
    const [isArchiveModalOpened, setIsArchiveModalOpened] = React.useState<
        boolean
    >(false);
    const uuidUser = localStorage.getItem("uuidUser");

    let dataArchive: any[] = [];

    if (!oneShop) {
        // eslint-disable-next-line
        dataArchive = archiveFidelity();
    }
    function archiveFidelity() {
        let idsAssociated: any = [];
        if (fidelityData.data !== undefined) {
            fidelityData.data.forEach((element: any) => {
                idsAssociated.push(element.Id);
            });
        }
        idsAssociated = [...new Set(idsAssociated)];
        return idsAssociated;
    }
    // eslint-disable-next-line
    async function activeFidelity() {
        toast.dismiss();
        let dataFidelity = {
            userId: userID,
            shopId: [e.selectedRow.shopId],
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            isShop: true,
            data: {
                [e.selectedRow.Id]: {
                    designation: e.selectedRow[t("Display name")],
                    type: e.selectedRow[t("Loyalty")],
                    number_fidelity_points:
                        e.selectedRow.number_fidelity_points,
                    money_correspondence: e.selectedRow.moneyCorrespondence,
                    devise: e.selectedRow.Devise,
                    pays: e.selectedRow.Pays,
                    authentication_mode: e.selectedRow.authentication_mode,
                    sortedVisibility: e.selectedRow.sortedVisibility,
                    Login: e.selectedRow.Login,
                    password: e.selectedRow[t("Password")],
                    note: e.selectedRow[t("Remark")],
                    isActive: false,
                    isArchived: false,
                    shopId: e.selectedRow.shopId,
                    dashboardLink: e.selectedRow["Dashboard Link"],
                    user: e.selectedRow.user,
                    apiKey: e.selectedRow["API key"],
                    auresKonnectGroup: e.selectedRow[t("Group")],
                    isCentralizationActive: e.selectedRow[t("State")],
                    isVisibiliteActive: e.selectedRow[t("isVisibiliteActive")],

                    fidelityChoiceIndex: e.selectedRow.fidelityChoiceIndex,
                },
            },
        };

        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/fidelity`;
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(dataFidelity),
        };
        try {
            mutate(
                apiUrlAdd,
                await fetch(apiUrlAdd, requestOptions)
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.error) {
                            throw Error("error");
                        }
                        toast.success(
                            `${t(
                                "The fidelity setting has been successfully unarchive"
                            )!}`,
                            {
                                position: toast.POSITION.TOP_CENTER,
                                theme: "colored",
                                icon: (
                                    <CheckboxIcon
                                        height={25}
                                        width={25}
                                        fill="white"
                                    />
                                ),
                            }
                        );
                        setDataIsUpdated!(true);
                    })
            );
        } catch (e: any) {
            toast.error(`${t("There's an error")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    }
    // eslint-disable-next-line
    async function handleStateChange() {
        let id = e.selectedRow.Id;
        let obj = {
            userId: userID,
            shopId: [e.selectedRow.shopId],
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            isShop: false,
            data: {
                [id]: {
                    designation: e.selectedRow[t("Display name")],
                    type: e.selectedRow[t("Loyalty")],
                    number_fidelity_points:
                        e.selectedRow.number_fidelity_points,
                    money_correspondence: e.selectedRow.moneyCorrespondence,
                    devise: e.selectedRow.Devise,
                    pays: e.selectedRow.Pays,
                    authentication_mode: e.selectedRow.authentication_mode,
                    sortedVisibility: e.selectedRow.sortedVisibility,
                    Login: e.selectedRow.Login,
                    password: e.selectedRow[t("Password")],
                    note: e.selectedRow[t("Remark")],
                    isArchived: false,
                    isActive: !fidelityState,
                    shopId: e.selectedRow.shopId,
                    auresKonnectGroup: e.selectedRow[t("Group")],
                    isCentralizationActive: e.selectedRow[t("State")],
                    isVisibiliteActive: e.selectedRow[t("isVisibiliteActive")],

                    fidelityChoiceIndex: e.selectedRow.fidelityChoiceIndex,
                },
            },
        };

        let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/fidelity`;
        mutate(
            apiUrl,
            await fetch(apiUrl, {
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(obj),
                method: "POST",
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error) {
                        throw Error(result.message);
                    }

                    toast.success(
                        !fidelityState
                            ? `${t(
                                  "The fidelity setting has been successfully activated"
                              )}`
                            : `${t(
                                  "The fidelity setting has been successfully deactivated"
                              )}`,

                        {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 2000,
                            theme: "colored",
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            icon: (
                                <CheckboxIcon
                                    height={25}
                                    width={25}
                                    fill="white"
                                />
                            ),
                        }
                    );
                    setDataIsUpdated!(true);
                })
                .catch((error: any) => {
                    toast.error(`${t("There's an error")!}`, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 2000,
                        theme: "colored",
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                })
        );
    }

    return (
        <React.Fragment>
            {e.selectedRow?.subRows === undefined ? (
                <div className="d-flex justify-content-around">
                    {modify === false || isFidelityArchived ? (
                        <Tooltip title={t("To consult")}>
                            <div>
                                {" "}
                                <ConsultSvgIcon
                                    className="pointer__clz afa_icn_toConsult"
                                    height={35}
                                    width={35}
                                    style={{
                                        cursor: "pointer",
                                        position: "relative",
                                        bottom: "5px",
                                    }}
                                    fill="black"
                                    onClick={() => {
                                        setFidelity(e.selectedRow);
                                        setIsAddFidelityClicked(true);
                                        setIsConsult(true);
                                    }}
                                />
                            </div>
                        </Tooltip>
                    ) : null}
                    {modify === true ? (
                        <>
                            <Tooltip
                                title={isFidelityArchived ? "" : t("configure")}
                            >
                                <div>
                                    <SettingsIcon
                                        onClick={() => {
                                            if (
                                                e.selectedRow[t("State")] ===
                                                true
                                            ) {
                                                toast.info(
                                                    `${t(
                                                        "Warning, you cannot modify a centralized store loyalty setting"
                                                    )!}`,
                                                    {
                                                        position:
                                                            toast.POSITION
                                                                .TOP_CENTER,
                                                        autoClose: 2000,
                                                        theme: "colored",
                                                        closeOnClick: true,
                                                        pauseOnHover: true,
                                                        draggable: true,
                                                    }
                                                );
                                            }

                                            setIsConsultModalOpened(true);
                                            setSelectedRows([e.selectedRow]);
                                        }}
                                        height={25}
                                        width={25}
                                        style={{ marginTop: "8px" }}
                                        className={`${classnames(
                                            "pointer__clz fed_icn_BTconsult",
                                            {
                                                "not-allowed-icon__clz": isFidelityArchived,
                                            }
                                        )}`}
                                    />
                                </div>
                            </Tooltip>
                            {/* <Tooltip
                                title={
                                    isFidelityArchived
                                        ? ""
                                        : fidelityState === false
                                        ? t("Activate")
                                        : t("Unactivate")
                                }
                            >
                                <div>
                                    <ReactSwitch
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        handleDiameter={26}
                                        offColor="#f7b4b8"
                                        offHandleColor="#E30613"
                                        checked={fidelityState}
                                        onChange={async () => {
                                            if (
                                                e.selectedRow
                                                    .fidelityChoiceIndex === 1
                                            ) {
                                                setIsModalOpenedSupport(true);
                                            } else {
                                                setFidelityState(
                                                    !fidelityState
                                                );
                                                handleStateChange();
                                            }
                                        }}
                                        onColor="#c2eddd"
                                        onHandleColor="#34C38F"
                                        width={50}
                                        height={20}
                                        className={`${classnames(
                                            "pointer__clz mt-2 cmn_icn_BTenableDisable",
                                            {
                                                "not-allowed-icon__clz": isFidelityArchived,
                                            }
                                        )}`}
                                    />
                                </div>
                            </Tooltip> */}
                            {/* {!isFidelityArchived ? (
                                <Tooltip
                                    title={
                                        e.selectedRow[t("State")] === true
                                            ? ""
                                            : t("Archive")
                                    }
                                >
                                    <div>
                                        <TrashIcon
                                            onClick={() => {
                                                if (
                                                    e.selectedRow
                                                        .fidelityChoiceIndex ===
                                                    1
                                                ) {
                                                    setIsModalOpenedSupport(
                                                        true
                                                    );
                                                } else {
                                                    setIsArchiveModalOpened(
                                                        true
                                                    );
                                                    setSelectedRowsFidelity([]);
                                                }
                                            }}
                                            height={25}
                                            width={25}
                                            fill="red"
                                            style={{ cursor: "pointer" }}
                                            className={`${classnames(
                                                "pointer__clz mt-2 cmn_icn_BTarchived",
                                                {
                                                    "not-allowed-icon__clz":
                                                        e.selectedRow[
                                                            t("State")
                                                        ] === true,
                                                }
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>
                            ) : (
                                <Tooltip
                                    title={
                                        dataArchive.includes(e.selectedRow.Id)
                                            ? ""
                                            : t("Unarchive")
                                    }
                                >
                                    <div>
                                        <EyeIcon
                                            height={25}
                                            width={25}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                if (
                                                    shopsFidelityData.othersData.allFidelity.data.filter(
                                                        (element: any) =>
                                                            element.shopId ===
                                                            e.selectedRow.shopId
                                                    )[0].subRows.length !== 0
                                                ) {
                                                    ErrorToast(
                                                        t(
                                                            "Attention,a shop cannot have more than one fidelity settings"
                                                        )
                                                    );
                                                } else {
                                                    activeFidelity();
                                                    setNumberActiveMultiShop(
                                                        numberActiveMultiShop +
                                                            1
                                                    );
                                                    setNumberArchiveMultiShop(
                                                        numberArchiveMultiShop -
                                                            1
                                                    );
                                                }
                                            }}
                                            className={`${classnames(
                                                "pointer__clz mt-2 mr-2 cmn_icn_BTunarchive",
                                                {
                                                    "not-allowed-icon__clz": dataArchive.includes(
                                                        e.selectedRow.Id
                                                    ),
                                                }
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>
                            )} */}
                        </>
                    ) : null}
                    {/* <Tooltip title={t("Consult history")}>
                        <div>
                            <TimePastSvgIcon
                                className="pointer__clz mt-2 cmn_icn_BThistory"
                                onClick={() => {
                                    if (
                                        e.selectedRow.fidelityChoiceIndex === 1
                                    ) {
                                        setIsModalOpenedSupport(true);
                                    } else {
                                        setIsHistoryModalOpened(
                                            !isHistoryModalOpened
                                        );
                                        setSelectedFidelity([
                                            {
                                                [e.selectedRow.shopId]:
                                                    e.selectedRow.Id,
                                            },
                                        ]);
                                        setSelectedRows([e.selectedRow]);
                                    }
                                }}
                            />
                        </div>
                    </Tooltip> */}
                </div>
            ) : null}
            {isArchiveModalOpened ? (
                <ConfirmationArchive
                    isModalOpened={isArchiveModalOpened}
                    setIsModalOpened={setIsArchiveModalOpened}
                    e={e}
                    setDataIsUpdated={setDataIsUpdated}
                    selectedRows={selectedRows}
                />
            ) : null}
        </React.Fragment>
    );
}
